import { render, staticRenderFns } from "./partnerRemittanceRanking.vue?vue&type=template&id=f1a48534&scoped=true&"
import script from "./partnerRemittanceRanking.vue?vue&type=script&lang=js&"
export * from "./partnerRemittanceRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a48534",
  null
  
)

export default component.exports